import { ErrorMessage, ErrorMessageProps } from 'formik';

export const FormFieldErrorMessage = (props: ErrorMessageProps) => <ErrorMessage {...props} className='text-danger' />;
